"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var Caption_1 = __importDefault(require("atomicComponents/atoms/Text/Caption"));
var Money_1 = __importDefault(require("components/Money"));
var single_1 = require("utils/selectors/single");
var TotalSpend = function (_a) {
    var _b, _c, _d;
    var value = _a.value;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Caption_1.default, __assign({ color: "neutral.main", mr: 1 }, { children: profile.mainCompanyId ? (_d = (_c = (_b = profile.companyData) === null || _b === void 0 ? void 0 : _b[profile.mainCompanyId]) === null || _c === void 0 ? void 0 : _c.baseCurrency) !== null && _d !== void 0 ? _d : 'AUD' : '' })), (0, jsx_runtime_1.jsx)(Money_1.default, { amount: value, isRounded: true })] }));
};
exports.default = TotalSpend;
